<h2 mat-dialog-title class="title">{{'form.edit'|translate}} {{data.title}}</h2>

<mat-dialog-content class="dialog-content">
  <mat-form-field appearance="outline">
    <mat-label>{{ name | translate }}</mat-label>
    <input id="name" [(ngModel)]="value" type="text" matInput> 
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <lib-button (click)="onCancel()" text="{{'form.cancel'|translate}}" color="outline" icon="close"></lib-button>
  <lib-button (click)="onSubmit()" color="primary" text="{{'form.submit'|translate}}" icon="done"></lib-button>
</mat-dialog-actions>